import { useEffect, useState } from "react";
import { apiError, api } from "@/lib/api";
import { formatPct, formatTRY } from "@/lib/format";
import { Stat } from "@/lib/finance";
import { has } from "@/lib/prim";

export default function MyPrim() {
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { api.get("/prim/me").then(({ data }) => setD(data)).catch((e) => setErr(apiError(e))); }, []);
  if (err) return <div className="panel p-6 text-slate-500" data-testid="my-prim-empty">{err}</div>;
  if (!d) return <div className="panel h-40 animate-pulse" />;
  return (
    <div className="space-y-3" data-testid="my-prim">
      <div className="text-[13px] text-slate-600">{d.period_label} · {d.method_label}{!d.prim_active && " (prim pasif)"}</div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <Stat label="Bu Ay Satışım" value={formatTRY(d.sales_try)} hint={`${d.order_count} sipariş · ${d.customer_count} müşteri`} testid="my-sales" />
        {has(d, "cost_try") && <Stat label="Maliyet" value={formatTRY(d.cost_try)} testid="my-cost" />}
        {has(d, "profit_try") && <Stat label="Brüt Kâr" value={formatTRY(d.profit_try)} tone="text-emerald-700" testid="my-profit" />}
        {has(d, "avg_margin_pct") && <Stat label="Ort. Marj" value={formatPct(d.avg_margin_pct)} testid="my-margin" />}
        {has(d, "estimated_prim") && <Stat label="Tahmini Prim" value={formatTRY(d.estimated_prim)} hint={d.last_run ? `Son dönem ${d.last_run.period_label}: ${formatTRY(d.last_run.prim_total)} (${d.last_run.status_label})` : ""} tone="text-blue-700" testid="my-prim-est" />}
        <Stat label="Tahsilatım" value={formatTRY(d.collections_try)} testid="my-collections" />
        <Stat label="Hedefim" value={d.monthly_target ? formatTRY(d.monthly_target) : "—"} hint={d.target_pct != null ? `%${d.target_pct} gerçekleşti` : ""} testid="my-target" />
      </div>
      {d.monthly_target > 0 && <div className="h-2 rounded bg-slate-100 overflow-hidden" data-testid="my-target-bar"><div className="h-full bg-blue-600" style={{ width: `${Math.min(100, d.target_pct)}%` }} /></div>}
    </div>
  );
}
